
export default {
  name: 'HeaderPromotionalBanner',
  props: {
    text: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      overflowing: this.text.length > 65,
      resetBanner: false,
      intervalId: null,
    }
  },

  beforeDestroy() {
    clearInterval(this.intervalId)
  },

  mounted() {
    if (!this.$device.isMobile) return
    this.overflowing = this.textOverflows()
    if (this.overflowing) {
      this.intervalId = window.setInterval(() => {
        if (this.$refs.scrollingContainer) {
          if (
            this.$refs.scrollingContainer.scrollLeft +
              this.$refs.scrollingContainer.offsetWidth >=
            this.$refs.scrollingContainer.scrollWidth
          ) {
            this.resetBanner = true
            setTimeout(this.scrollToStart, 600)
          } else if (!this.resetBanner) {
            this.$refs.scrollingContainer.scrollLeft += 1
          }
        }
      }, 30)
    }
  },

  methods: {
    textOverflows() {
      const container = this.$refs.scrollingContainer
      const text = this.$refs.text
      if (!container || !text) return false
      const style = window.getComputedStyle(container)
      const room =
        container.clientWidth -
        parseFloat(style.paddingLeft) -
        parseFloat(style.paddingRight)
      return text.offsetWidth > room
    },
    scrollToStart() {
      if (!this.$refs.scrollingContainer) return
      this.$refs.scrollingContainer.scrollLeft = 0
      this.resetBanner = false
    },
  },
}
